import { createFileRoute } from '@tanstack/react-router'

import AiChat from '@/components/organisms/ai-chat'

export const Route = createFileRoute('/_authenticated/(developer)/ai-chat')({
  component: AiChatPage,
})

function AiChatPage() {
  return <AiChat />
}
